import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTE_TRANSITION } from '../../../app.animation';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import * as moment from 'moment';

import { environment } from '../../../../environments/environment';
import { UpdateEnterpriseService } from '../../enterprises/update-enterprise/update-enterprise.service';
import { AuthGuard } from '../../../core/auth/auth.guard';

@Component({
  selector: 'vr-forgot-password-token',
  templateUrl: './forgot-password-token.component.html',
  styleUrls: ['./forgot-password-token.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class ForgotPasswordTokenComponent implements OnInit {

  token: string;
  password: string;
  password_confirm: string;

  constructor(
    private router: Router,
    private i18n: I18n,
    private http: HttpClient,
    private matSnackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe( params => {
      this.token = params['token'];
    });
  }

  /**
   * Check if token is expired
   */
  ngOnInit() {
    const split = this.token.split(':');
    if (moment(split[1], 'YYMMDDHHmmss').isBefore(moment().subtract(1, 'hour'))) {
      this.matSnackBar.open(this.i18n({value: 'Expired token, please send a new request for your password.', id: 'EmailSendLostPasswordTokenExpired'}), '', {duration: 5000} as MatSnackBarConfig);
    }
  }

  /**
   * Send request to update password
   */
  send() {
    this.http.post(environment.API_PATH + 'auth/change-password', {token: this.token, password: this.password, password_confirm: this.password_confirm}, {withCredentials: true}).subscribe((response) => {
      if (response['success']) {
        this.matSnackBar.open(this.i18n({value: 'Password successfully changed', id: 'PasswordSuccessfulyChanged'}), '', {duration: 5000} as MatSnackBarConfig);
        this.router.navigate(['auth/login']).then();
      } else if (response['errors']['general']['code'] === 'EXPIRED_TOKEN') {
        this.matSnackBar.open(this.i18n({value: 'Expired token, please send a new request for your password.', id: 'EmailSendLostPasswordTokenExpired'}), '', {duration: 5000} as MatSnackBarConfig);
      } else if (response['errors']['general']['code'] === 'USER_DOES_NOT_EXIST') {
        this.matSnackBar.open(this.i18n({value: 'Expired token, please send a new request for your password.', id: 'EmailSendLostPasswordTokenExpired'}), '', {duration: 5000} as MatSnackBarConfig);
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/forgot-password-token/forgot-password-token.component.ts